import { basicEnum } from "./base";

export const InstallationStepStatusEnum = basicEnum([
    {
        label: "EMPTY",
        value: "E",
    },
    {
        label: "INITIALIZED",
        value: "I",
    },
    {
        label: "STARTED",
        value: "S",
    },
    {
        label: "FINISHED",
        value: "F", // Filling reports and used items
    },
    {
        label: "REPORTED",
        value: "R", // Filling items price
    },
    {
        label: "DONE",
        value: "D",
    },
]);

export namespace InstallationStepStatusEnum {
    export type Labels = (typeof InstallationStepStatusEnum)["labels"][number];
    export type Values = (typeof InstallationStepStatusEnum)["values"][number];
}
